export default __webpack_public_path__ + "static/media/blank.f286200e.jpg";